import { render, staticRenderFns } from "./DocsLanding.vue?vue&type=template&id=24a6fc57&scoped=true"
import script from "./DocsLanding.vue?vue&type=script&lang=js"
export * from "./DocsLanding.vue?vue&type=script&lang=js"
import style0 from "./DocsLanding.vue?vue&type=style&index=0&id=24a6fc57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6fc57",
  null
  
)

export default component.exports